const mediaApiPath = "/episerverapi/media/metadata";
const emptyResponse = {
  "mediaObjects": {
    "@xmlns:xsd": "http://www.w3.org/2001/XMLSchema",
    "@xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance",
    "@count": "0",
    "@totalCount": "0",
    "mediaObject": []
  }
};

export function BuildProjectGalleryRequest(mediaSettings) {
  let request = buildMediaObjectRequest(mediaSettings);
  request.page = [1];
  request.pageSize = [15];

  return request;
}

export function BuildVideoGalleryRequest(mediaSettings) {
  let request = buildMediaObjectRequest(mediaSettings);
  request.page = [1];
  request.pageSize = [20];

  return request;
}

export function BuildDocumentWarrantiesRequest(mediaSettings) {
  return buildMediaObjectRequest(mediaSettings);
}

export async function FetchMediaObjects(options) {
  const response = await fetch(
    mediaApiPath,
    {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(options)
    }
  );

  try {
    let mediaObjectsResult = await response.json();
    return mediaObjectsResult;
  }
  catch (exception) {
    return emptyResponse;
  }
}

function buildMediaObjectRequest(mediaSettings) {
  let request = {
    format: [mediaSettings.Format]
  };

  mediaSettings.Filters.forEach(filter => {
    var current = request[filter.Item1] || [];
    request[filter.Item1] = [...current, filter.Item2];
  });

  return request;
}